import { Card, Col, Collapse, Form, List, Input, Modal, Row } from "antd";
import { FC } from "react";

const { Panel } = Collapse;

type ViewResubmissionCghsProps = {
  resubmissionList: any;
  closeViewResubmissionModal?: any;
  viewResubmissionCghs?: boolean;
  isFetchingResubmissionData: boolean;
  isCghsNew?: boolean;
};

const ViewResubmissionCghs: FC<ViewResubmissionCghsProps> = (props) => {
  const calculateTotal = (data: any[]) => {
    return data?.reduce((sum: number, procedure: any) => {
      const amount = procedure?.unspecifiedProcedureAmount
        ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
          parseFloat(procedure?.numberOfDays)
        : parseFloat(procedure?.procedureAmount || "0") *
          parseFloat(procedure?.numberOfDays);
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  return (
    // <Modal
    //   loading={props?.isFetchingResubmissionData}
    //   title={
    //     <div>
    //       <span style={{ fontSize: "1rem", fontWeight: "600" }}>
    //         RESUBMISSION
    //       </span>
    //     </div>
    //   }
    //   centered
    //   width={2000}
    //   open={props?.viewResubmissionCghs}
    //   onCancel={props?.closeViewResubmissionModal}
    //   footer={null}
    //   style={{ boxShadow: "0px 4px 20px 0px #00000040", width: "149%" }}
    //   className="new-view-enhancement-ihx"
    // >
    <div>
      <List
        grid={{ gutter: 16, column: 1 }}
        dataSource={props?.resubmissionList}
        renderItem={(item: any, index) => (
          <List.Item>
            <Collapse className="resubmission-header-card" defaultActiveKey={["0"]}>
              <Panel
                header={`Resubmission-${props?.resubmissionList?.length - index}`}
                key={index}
              >
                <Card
                  // title={`Resubmission-${props?.resubmissionList?.length - index}`}
                  className="enhancement-card resubmission-card"
                  style={{ cursor: "pointer", backgroundColor: "white" }}
                >
                  <Collapse defaultActiveKey={["1"]}>
                    <Panel header="Procedure" key="1">
                      <Form>
                        {item?.reSubmissionProcedures &&
                        item?.reSubmissionProcedures?.length > 0 ? (
                          item?.reSubmissionProcedures?.map(
                            (procedure: any) => (
                              <Row
                                key={procedure?.id}
                                gutter={[16, 16]}
                                align="top"
                                style={{
                                  border: "1px solid #00549e",
                                  padding: "10px 20px",
                                  borderRadius: "16px",
                                  marginBottom: "0.8rem",
                                  background: "white",
                                  boxShadow: "0px 2px 8px 0px #00000040",
                                }}
                              >
                                {/* <Col span={8}>
                              <Form.Item
                                label="PROCEDURE REFERRAL"
                                name={"procedureReferral"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={procedure?.procedureReferral}
                                  disabled={true}
                                  style={{ color: "black" }}
                                />
                              </Form.Item>
                            </Col> */}

                                <Col span={10}>
                                  <Form.Item
                                    label="Procedure"
                                    name={"procedureName"}
                                    rules={[
                                      { required: true, message: "Required" },
                                    ]}
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Input
                                      defaultValue={procedure?.procedureName}
                                      disabled={true}
                                      style={{ color: "black" }}
                                    />
                                  </Form.Item>
                                </Col>

                                <Col span={4}>
                                  <Form.Item
                                    label="Procedure Code"
                                    name={"externalProcedureCode"}
                                    rules={[
                                      { required: true, message: "Required" },
                                    ]}
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Input
                                      style={{
                                        borderRadius: "5px",
                                        color: "black",
                                      }}
                                      placeholder="Enter Procedure Code"
                                      disabled={true}
                                      defaultValue={
                                        procedure?.externalProcedureCode
                                      }
                                    />
                                  </Form.Item>
                                </Col>

                                <Col span={5}>
                                  <Form.Item
                                    label="QUANTITY/NO OF DAYS"
                                    name={"numberOfDays"}
                                    rules={[
                                      { required: true, message: "Required" },
                                    ]}
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Input
                                      defaultValue={procedure?.numberOfDays}
                                      disabled={true}
                                      placeholder="Enter QUANTITY/NO OF DAYS"
                                      style={{
                                        borderRadius: "5px",
                                        color: "black",
                                      }}
                                    />
                                  </Form.Item>
                                </Col>

                                {/* <Col span={8}>
                              <Form.Item
                                label="ACCREDITATION STATUS"
                                name={"accreditationStatus"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  disabled={true}
                                  defaultValue={procedure?.accreditationStatus}
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={7}>
                              <Form.Item
                                label="TREATING DOCTOR"
                                name={"treatingDoctor"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  disabled={true}
                                  defaultValue={procedure?.treatingDoctor}
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                />
                              </Form.Item>
                            </Col> */}

                                <Col span={5}>
                                  <Form.Item
                                    label="TREATMENT START DATE"
                                    name={"treatmentStartDate"}
                                    rules={[
                                      { required: true, message: "Required" },
                                    ]}
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      width: "100%",
                                    }}
                                  >
                                    <Input
                                      disabled={true}
                                      defaultValue={
                                        procedure?.treatmentStartDate
                                      }
                                      style={{ color: "black" }}
                                    />
                                  </Form.Item>
                                </Col>

                                {!procedure?.specialityType
                                  ?.toLowerCase()
                                  ?.includes("s") && !procedure?.unspecifiedProcedureAmount ? (
                                  <Col span={8}>
                                    <Form.Item
                                      label="AMOUNT"
                                      name={"procedureAmount"}
                                      rules={[
                                        { required: true, message: "Required" },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        defaultValue={
                                          procedure?.procedureAmount
                                        }
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Amount"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : (
                                  <></>
                                )}

                                {procedure?.specialityType
                                  ?.toLowerCase()
                                  ?.includes("s") || procedure?.unspecifiedProcedureAmount ? (
                                  <Col span={8}>
                                    <Form.Item
                                      label="PROCEDURE NAME"
                                      name={"unspecifiedProcedureName"}
                                      rules={[
                                        { required: true, message: "Required" },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        defaultValue={
                                          procedure?.unspecifiedProcedureName
                                        }
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Procedure Name"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : (
                                  <></>
                                )}

                                {procedure?.specialityType
                                  ?.toLowerCase()
                                  ?.includes("s") || procedure?.unspecifiedProcedureAmount ? (
                                  <Col span={7}>
                                    <Form.Item
                                      label="PROCEDURE AMOUNT"
                                      name={"unspecifiedProcedureAmount"}
                                      rules={[
                                        { required: true, message: "Required" },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        defaultValue={
                                          procedure?.unspecifiedProcedureAmount
                                        }
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Procedure Amount"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : (
                                  <></>
                                )}

                                {procedure?.strats
                                  ?.toLowerCase()
                                  ?.includes("y") ? (
                                  <Col span={7}>
                                    <Form.Item
                                      label="STRATS NAME"
                                      name={"stratsName"}
                                      rules={[
                                        { required: true, message: "Required" },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        defaultValue={procedure?.stratsName}
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Strats Name"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : (
                                  <></>
                                )}

                                {procedure?.strats
                                  ?.toLowerCase()
                                  ?.includes("y") ? (
                                  <Col span={8}>
                                    <Form.Item
                                      label="STRATS OPTIONS"
                                      name={"stratOptionValue"}
                                      rules={[
                                        { required: true, message: "Required" },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        defaultValue={
                                          procedure?.stratOptionValue
                                        }
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Strats Option"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : (
                                  <></>
                                )}

                                {props?.isCghsNew ? (
                                  <Col span={8}>
                                    <Form.Item
                                      label="Resubmission Reason"
                                      name={"reason"}
                                      rules={[
                                        { required: true, message: "Required" },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: "100%",
                                      }}
                                    >
                                      <Input
                                        disabled={true}
                                        defaultValue={item?.reason}
                                        style={{ color: "black" }}
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : (
                                  <></>
                                )}

                                <Col span={8}>
                                  <Form.Item
                                    label="Remarks"
                                    name={"remarks"}
                                    rules={[
                                      { required: true, message: "Required" },
                                    ]}
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      width: "100%",
                                    }}
                                  >
                                    <Input
                                      disabled={true}
                                      defaultValue={item?.remarks}
                                      style={{ color: "black" }}
                                    />
                                  </Form.Item>
                                </Col>

                                <div style={{ width: "100%" }}>
                                  <h4
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                    }}
                                  >
                                    Amount: ₹{" "}
                                    {!procedure?.specialityType
                                      ?.toLowerCase()
                                      ?.includes("s") && !procedure?.unspecifiedProcedureAmount
                                      ? parseFloat(procedure?.numberOfDays) *
                                        parseFloat(procedure?.procedureAmount)
                                      : parseFloat(procedure?.numberOfDays) *
                                        parseFloat(
                                          procedure?.unspecifiedProcedureAmount,
                                        )}
                                    /-
                                  </h4>
                                </div>
                              </Row>
                            ),
                          )
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            NO PROCEDURE
                          </div>
                        )}

                        {item?.reSubmissionProcedures &&
                        item?.reSubmissionProcedures?.length > 0 ? (
                          <div
                            style={{ width: "100%", marginBottom: "0.8rem" }}
                          >
                            <h4
                              style={{ display: "flex", justifyContent: "end" }}
                            >
                              Total Amount: ₹{" "}
                              {calculateTotal(item?.reSubmissionProcedures) ??
                                0}
                              /-
                            </h4>
                          </div>
                        ) : (
                          <></>
                        )}
                      </Form>
                    </Panel>
                  </Collapse>
                </Card>
              </Panel>
            </Collapse>
          </List.Item>
        )}
      />
    </div>
  );
};

export default ViewResubmissionCghs;
